import React from 'react'
import { PreloaderLine } from '@rst/ui-ts'
import {
	calcBlockHeight,
	media,
	formatText,
	usePreloaderFont,
} from '@rst/libs-ts'
import styled from 'styled-components'

export const LeadFormContactDeskPreloader = (data: any) => {
	const descr = formatText(data.subtitle)
	const heightTitle = calcBlockHeight(
		data.title,
		usePreloaderFont(data),
		data.title_size,
		110,
		window.innerWidth < 1200 ? window.innerWidth * 0.6 - 103 : 636
	)

	return (
		<>
			<ContWrapp align={data.align}>
				<Cont align={data.align}>
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<SocialBtns>
						<PreloaderLine />
						<PreloaderLine />
						<PreloaderLine />
					</SocialBtns>
				</Cont>
			</ContWrapp>
			<LeadWrapp align={data.align}>
				<Lead align={data.align}>
					<Header heightTitle={heightTitle}>
						<PreloaderLine />
						<Desc>
							{descr.map((x: { tag: string; text: any }, i: any) =>
								x.tag === 'ulArr' ? (
									<UlWrapp>
										{x.text.map((z: any) => (
											<PreloadUl {...data} {...z} />
										))}
									</UlWrapp>
								) : (
									<AnotherTag>
										<PreloadSubTitle {...data} {...x} key={i} />
									</AnotherTag>
								)
							)}
						</Desc>
					</Header>
					<Form>
						<TopForm>
							<PreloaderLine />
							<PreloaderLine />
						</TopForm>
						<TextArea>
							<PreloaderLine />
						</TextArea>
					</Form>
					<ButtonBlock>
						<PreloaderLine />
						<Info>
							<PreloaderLine />
							<PreloaderLine />
							<PreloaderLine />
						</Info>
					</ButtonBlock>
				</Lead>
			</LeadWrapp>
		</>
	)
}

const PreloadSubTitle = (data: any) => {
	const heightDescription = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		150,
		window.innerWidth < 1200 ? window.innerWidth * 0.6 - 103 : 636,
		data
	)

	return <PreloaderLine tag={data.tag} height={heightDescription} />
}

const PreloadUl = (data: any) => {
	const heightUl = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		150,
		window.innerWidth < 1200 ? window.innerWidth * 0.6 - 103 : 636,
		data
	)

	return <PreloaderLine tag={data.tag} height={heightUl} />
}

const Desc = styled.div`
	width: 100%;
	& > div {
		width: 100%;

		&:last-child {
			margin-bottom: 0;
		}
	}
`

const UlWrapp = styled.div`
	display: flex;
	flex-direction: column;
`

const AnotherTag = styled.div`
	margin-bottom: 0;
`

const LeadWrapp = styled.div<{ align: string }>`
	flex-basis: 60%;
	display: flex;
	justify-content: ${p => (p.align === 'right' ? 'left' : 'right')}; ;
`

const ContWrapp = styled.div<{ align: string }>`
	flex-basis: 40%;
	display: flex;
	justify-content: ${p => (p.align === 'right' ? 'right' : 'left')};
`

const Lead = styled.div<{ align: string }>`
	flex-direction: column;
	justify-content: center;
	width: 100%;
	max-width: 700px;

	padding: ${p =>
		p.align === 'left' ? '56px 64px 56px 0px' : '56px 0px 56px 64px'};

	${media.pure.less(media.size.lg)} {
		padding: ${p =>
			p.align === 'left' ? '56px 32px 56px 60px' : '56px 60px 56px 32px'};
	}
`

const SocialBtns = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;

	& > div {
		height: 40px;
		width: 40px;
		border-radius: 20px;
	}
`

const Cont = styled.div<{ align: string }>`
	display: flex;
	width: 40%;
	flex-direction: column;
	min-width: 450px;
	padding: 56px 48px;

	& > div {
		&:nth-child(1) {
			height: 27px;
			width: 50%;
			margin-bottom: 26px;
		}
		&:nth-child(2) {
			height: 24px;
			width: 43%;
			margin-bottom: 15px;
		}
		&:nth-child(3) {
			height: 16px;
			width: 40%;
			margin-bottom: 8px;
		}
		&:nth-child(4) {
			height: 16px;
			width: 38%;
			margin-bottom: 18px;
		}
		&:nth-child(5) {
			height: 24px;
			width: 37%;
			margin-bottom: 15px;
		}
		&:nth-child(6) {
			height: 16px;
			width: 35%;
			margin-bottom: 8px;
		}
		&:nth-child(7) {
			height: 16px;
			width: 38%;
			margin-bottom: 18px;
		}
		&:nth-child(8) {
			height: 24px;
			width: 37%;
			margin-bottom: 15px;
		}
		&:nth-child(9) {
			height: 16px;
			width: 70%;
			margin-bottom: 8px;
		}
		&:nth-child(10) {
			height: 16px;
			width: 50%;
			margin-bottom: 26px;
		}
	}
`

const Header = styled.div<{ heightTitle: number }>`
	gap: 8px;
	display: flex;
	flex-direction: column;

	& > div {
		&:nth-child(1) {
			height: ${p => `${p.heightTitle}px`};
			width: 100%;
		}
	}
`

const Form = styled.div`
	margin-top: 40px;
`

const TopForm = styled.div`
	gap: 8px;
	display: flex;
	flex-direction: row;
	& > div {
		width: 100%;
		height: 56px;

		&:last-child {
			margin-right: 50px;
		}
	}
`

const TextArea = styled.div`
	margin-top: 8px;
	& > div {
		display: flex;
		height: 102px;
	}
`

const Info = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-height: 54px;
	justify-content: space-between;
	${media.pure.less(media.size.lg)} {
		min-height: 72px;
	}
	& > div {
		height: 10px;

		&:nth-child(2) {
			width: 60%;
		}

		&:nth-child(3) {
			width: 75%;
		}
	}
`

const ButtonBlock = styled.div`
	display: flex;
	gap: 10px;
	margin-top: 16px;
	& > div {
		display: flex;
		width: 100%;

		&:nth-child(1) {
			height: 48px;
		}

		&:first-child {
			width: 60%;
		}
	}
`
